import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Row, Modal, Table, Form, Pagination, InputGroup, FormControl } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import avatar1 from '../assets/images/user/avatar-1.jpg';
import avatar2 from '../assets/images/user/avatar-2.jpg';
import camera from '../assets/images/svg/camera.svg';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import { errorResponse } from '../helper/error';
import Loader from './Loader/Loader';
import { toast } from 'react-toastify';
import PaginationC from './pagination';

const ProductAdBanner = (props) => {

    const serverURL = getServerURL()
    const fileInputRef = useRef(null);

    const [modalShow, setModalShow] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [searchText, setSearchText] = useState("");

    const [states, setStates] = useState({ is_main: false, index: "" })
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([])
    const [pageList, setPageList] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState()
    const [selectedImage, setSelectedImage] = useState()
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)
    const [subLoader, setSubLoader] = useState(false)

    useEffect(() => {
        getPageBanner();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    useEffect(() => {
        getPageName();
    }, []);

    const getPageName = (event) => {
        api.getWithToken(`${serverURL}page/`)
            .then(async (res) => {
                if (res?.data?.success === true) {
                    setPageList(res?.data?.data);
                }
            })
            .catch((e) => {
            });
    };

    const getPageBanner = (event) => {
        api.getWithToken(`${serverURL}page/banner/?_m=0&page=${page}${searchText && `&_s=${searchText}`}`)
            .then(async (res) => {
                setLoading(false)
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                if (res?.data?.success === true) {
                    setData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (["checkbox", "radio"].includes(type)) {
            setStates((prevValues) => ({
                ...prevValues,
                [name]: checked,
            }));
        }
        else {
            if (name === "image") {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        setSelectedImage(reader.result);
                    };
                    reader.readAsDataURL(file);
                    setStates({
                        ...states,
                        [name]: file,
                    });
                }
            }
            else {
                setStates((prevValues) => ({
                    ...prevValues,
                    [name]: value.trimStart(),
                }));
            }
        }
    };

    const handleSubmit = (event) => {

        // if(!states?.is_main && states?.index === ""){
        //     toast.error("Please enter index.")
        // }
        setSubLoader(true)
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity()) {
            setValidated(false);
            const type = Boolean(mode) ? "postWithToken" : "putWithToken";
            const formData = new FormData();
            if (!states?.is_main && states?.index !== "")
                formData.append("index", states?.index);
            formData.append("page", states?.page_slug);
            formData.append("image", states?.image);
            formData.append("is_main", states?.is_main || false);
            formData.append("title", states?.title || "");
            formData.append("description", states?.description || "");
            if (states?.id)
                formData.append("id", states?.id);

            setLoading(true);
            setSubLoader(false)
            api[type](`${serverURL}page/banner/`, formData)
                .then(async (res) => {
                    setModalShow(false)
                    setStates({})
                    form.reset();
                    setLoading(false);
                    if (res?.data?.success === true) {
                        toast.success(res?.data?.message);
                        getPageBanner();
                    } else if (res?.data?.success === false) {
                        if (typeof res?.data?.message === "string")
                            toast.error(res?.data?.message);
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    setSubLoader(false)
                    errorResponse(e);
                });
        } else {
            setValidated(true);
            setLoading(false);
            setSubLoader(false)
            event.stopPropagation();
        }
    };

    const deletePageBanner = () => {
        setSubLoader(true)
        api.deleteWithToken(`${serverURL}page/banner/${deleteData}`)
            .then(async (res) => {
                setDeleteModalShow(false)
                if (res?.data?.success === true) {
                    toast.success(res?.data?.message);
                    getPageBanner()
                } else if (res?.data?.success === false) {
                    if (typeof res?.data?.message === "string")
                        toast.error(res?.data?.message);
                }
                setSubLoader(false)
            })
            .catch((e) => {
                errorResponse(e);
                setSubLoader(false)
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}>
                                <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                            <Button variant={"outline-primary"} className='m-0' onClick={() => { setMode(true); setStates({ is_main: false, index: "" }); setModalShow(true) }}>
                                {"Add"}
                            </Button>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Image</th>
                                <th>Page Name</th>
                                <th>Index</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Main</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>

                                    <tr>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <img className="rounded-circle" style={{ width: '40px' }} src={item?.image} alt="activity-user" />
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.page || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.index || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.title || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.description || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{Boolean(item?.is_main)?.toString() || "-"}</h6>
                                        </td>
                                        <td>
                                            <div className='d-flex align-items-center gap-3'>
                                                <div className='cursor-pointer' onClick={() => { setMode(false); setStates(item); setModalShow(true) }}>
                                                    <i className="feather icon-edit" title='Edit' />
                                                </div>
                                                <div className='cursor-pointer' onClick={() => { setDeleteData(item?.id); setDeleteModalShow(true) }}>
                                                    <i className="feather icon-trash-2" title='Delete' />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={6} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />}

            {/* add modal */}
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <Card.Title as="h5">{Boolean(mode) ? "Add " : "Edit "} {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body>
                        {Boolean(subLoader) && <Loader loading={subLoader} />}
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Form.Group className={`mb-4 ${!Boolean(mode) && "align-items-center"}`} as={Row} controlId="formHorizontalFirstName">
                                    <Form.Label column sm={3}>
                                        Image
                                    </Form.Label>
                                    <Col sm={9}>
                                        {/* {Boolean(mode) ?
                                            <InputGroup>
                                                <Form.Control aria-describedby="custom-addons6" type="file" className="custom-file-input" id="validatedCustomFile2" required name='image' onChange={handleChange} />
                                                <Form.Control.Feedback type="invalid">Please select image.</Form.Control.Feedback>
                                            </InputGroup>
                                            : */}
                                        <div className="position-relative" id="profile_image">
                                            <div className="d-flex">
                                                <img
                                                    src={selectedImage || states?.image}
                                                    onClick={handleImageClick}
                                                    className={`cursor-pointer profile-image`}
                                                />
                                            </div>
                                            <input
                                                type="file"
                                                // accept="image/*"
                                                    accept=".jpg, .jpeg, .png, webm, .webp"
                                                name="image"
                                                style={{ display: "none" }}
                                                ref={fileInputRef}
                                                onChange={handleChange}
                                            />

                                            <img
                                                src={camera}
                                                onClick={handleImageClick}
                                                className="cursor-pointer position-absolute top-50 start-20 translate-middle"
                                                alt=""
                                            />
                                        </div>
                                        {/* } */}
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Page Name
                                    </Form.Label>
                                    <Col sm={9}>
                                        <InputGroup>
                                            <FormControl as="select" aria-describedby="custom-addons1" className="custom-select" value={states?.page_slug || ""} name='page_slug' onChange={handleChange} required>
                                                <option value={""} disabled>Select page name</option>
                                                {Boolean(pageList?.length) &&
                                                    pageList?.map((item, index) => <option key={index + "pageList"} value={item?.slug}>{item?.name}</option>)}
                                            </FormControl>
                                            <Form.Control.Feedback type="invalid">Please select page.</Form.Control.Feedback>
                                        </InputGroup>
                                    </Col>
                                </Form.Group>

                                {/* <Form.Group className="mb-3 align-items-center" as={Row} controlId="formHorizontalCheck">
                                    <Form.Label as="legend" column sm={3}>
                                        Is Main
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Check label="True" name="is_main" checked={states?.is_main || ""} onChange={handleChange} />
                                    </Col>
                                </Form.Group> */}

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Index
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="number" placeholder="Enter index here" value={states?.index || ""} name='index' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Title
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter title here" value={states?.title || ""} name='title' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <Form.Group className="mb-4" as={Row} controlId="formHorizontalName">
                                    <Form.Label column sm={3}>
                                        Description
                                    </Form.Label>
                                    <Col sm={9}>
                                        <Form.Control type="text" placeholder="Enter description here" value={states?.description || ""} name='description' onChange={handleChange} />
                                    </Col>
                                </Form.Group>

                                <div className='d-flex justify-content-end'>
                                    <Button type='submit' className='m-0'>{Boolean(mode) ? "Save" : "Update"}</Button>
                                </div>

                            </Form>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>

            {/* Delete */}
            <Modal
                show={deleteModalShow}
                onHide={() => setDeleteModalShow(false)}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                {Boolean(subLoader) && <Loader loading={subLoader} />}
                    <Card className='mb-0' style={{ borderBottom: "1px solid #f1f1f1" }}>
                        <Card.Header className='d-flex justify-content-between align-items-center pe-0 pt-0 pb-0'>
                            <Card.Title as="h5">Delete {props?.title}</Card.Title>
                            <Modal.Header closeButton className='border-0'>
                            </Modal.Header>
                        </Card.Header>
                        <Card.Body className='pb-2'>
                            <h6>Are you sure you want to delete?</h6>
                            <div className='d-flex justify-content-center'>
                                <Button onClick={() => deletePageBanner()} className='mt-3 mb-0 mx-0'>Delete</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ProductAdBanner